export default __webpack_public_path__ + "static/media/Matumelo_Matsoana.f3d9e133.jpeg";